var staticStrUndefined = 'undefined'

module.exports = staticStrUndefined



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticStrUndefined.js
// module id = dvNE
// module chunks = 141